import { useLang } from "@/context/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  if (!t) return null;
  const words = t.marquee || [];
  const loop = [...words, ...words];

  return (
    <section className="bg-noir text-creme py-6 overflow-hidden border-y border-creme/10" data-testid="marquee-container" aria-hidden="true">
      <div className="marquee-track">
        {loop.map((w, i) => (
          <span key={`${w}-${i}`} className="flex items-center shrink-0">
            <span className="font-serif text-2xl md:text-3xl px-8 text-creme/90">{w}</span>
            <span className="text-rouge text-2xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
